import React from "react";
import Slider from "react-slick";
const About = () => {
  var settings = {
    centerMode: true,
    centerPadding: 0,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };
  var settings2 = {
    centerMode: true,
    centerPadding: 0,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="cms-section">
            <div className="heading">
              <h2>About Us</h2>
            </div>
            <div className="whitebox">
              <div className="aboutus">
                <div className="aboutus-content">
                  <figure>
                    <img src="images/aboutus-experience.jpg" alt="img" />
                  </figure>
                  <p>
                    MyClubtap is Australia's 1st fantasy platform for grassroot
                    sporting clubs and leagues. One single platform, that
                    provides community clubs and leagues an easy way to have
                    their own fantasy leagues, paves way for a brand new digital
                    avenue for fundraising, enhance engagement with family,
                    friends and fans, foster mentoring opportunities between
                    clubs own players and a new avenue to promote clubs own
                    local sponsors.
                  </p>
                  <p>
                    A game of skill, MyClubtap offers sport clubs and leagues
                    fans a platform to showcase their club sport knowledge, by
                    creating their own fantasy team of real local club players,
                    score fantasy points based on the players on-field
                    performances and compete with every other fan and follower
                    of their favorite clubs in a battle for bragging rights,
                    banter and prizes offered by the respective clubs and
                    leagues.
                  </p>
                  <p>
                    MyClubtap enables direct connect and higher engagement of
                    clubs fans and followers with community sports, enabling
                    them to follow club players who may be one of their own.
                    They may themselves not play community sport, but can now
                    become an owner of a fantasy team and follow their favorite
                    local sports and stars.
                  </p>
                </div>
                <div className="ourvision-section">
                  <div className="visionbox">
                    <figure>
                      <img src="images/vision-img.jpg" alt="img" />
                    </figure>
                    <div className="visioncontent">
                      <h4>our vision</h4>
                      <p>
                        To be the home of fantasy sports for grassroots sport.
                      </p>
                    </div>
                  </div>
                  <div className="visionbox">
                    <figure>
                      <img src="images/mission-img.jpg" alt="img" />
                    </figure>
                    <div className="visioncontent">
                      <h4>our mission</h4>
                      <p>
                        To empower communities to connect, collaborate,
                        participate and thrive through grassroots sporting
                        clubs.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="our-team">
                  <h2>Our Team</h2>
                  <div className="vertical-center-3 ourteam">
                    <Slider {...settings2}>
                      <div>
                        <div className="teambox">
                          <figure>
                            <img src="images/our-team1.png" alt="img" />
                          </figure>
                          <div className="teamcontent">
                            <h4>Vicky Goyal</h4>
                            <span>Founder &amp; Director</span>
                            <ul className="sponsor-social">
                              <li>
                                <a href="https://www.facebook.com/vickygoyal29">
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li>
                                <a href="https://twitter.com/VG_MyClubtap">
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                              <li>
                                <a href="https://www.instagram.com/vickygoyal29/">
                                  <i className="fab fa-linkedin-in"></i>
                                </a>
                              </li>
                              <li>
                                <a href="https://www.linkedin.com/in/vickygoyal/">
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="teambox">
                          <figure>
                            <img src="images/vikashdp.png" alt="img" />
                          </figure>
                          <div className="teamcontent">
                            <h4>Vikash Rathor</h4>
                            <span>Sales & Marketing Associate</span>
                            <ul className="sponsor-social">
                              <li>
                                <a href="https://www.linkedin.com/in/vikash-rathor-6a36a7269/">
                                  <i className="fab fa-linkedin-in"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
              <div className="club_block">
                <h3>Clubs &amp; Leagues We Serve</h3>
                <div className="vertical-center-3 testimonial">
                  <Slider {...settings}>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-1.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-2.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-3.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-4.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-5.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-6.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-7.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-8.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-9.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                    <div>
                      <div className="clublogo">
                        <figure>
                          <img src="images/club-10.png" alt="img" />
                        </figure>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
              <div className="about_block">
                <h3>Reviews &amp; Rating</h3>
                <div className="vertical-center-3 testimonial">
                  <Slider {...settings2}>
                    <div>
                      <div className="card">
                        <div className="image_box">
                          <figure>
                            <img
                              src="images/reviews-user.jpg"
                              alt="reviews-user"
                            />
                          </figure>
                          <div className="images_box_content">
                            <h4>Darcy Middleton</h4>
                            <strong className="user-company">
                              Game Admin, Mt Lawley-Inglewood Cricket Club
                            </strong>
                            <strong className="user-location">Perth, WA</strong>
                            <span>
                              <img
                                src="images/reviews-rating.png"
                                alt="reviews-rating"
                              />
                            </span>
                          </div>
                        </div>
                        <p>
                          "Vicky does a fantastic job with MyClubtap - the
                          system is easy to use, looks fantastic and is a great
                          way to both raise money for the club and for players
                          to bond off field. Could not recommend it enough!"
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="card">
                        <div className="image_box">
                          <figure>
                            <img
                              src="images/reviews-user.jpg"
                              alt="reviews-user"
                            />
                          </figure>
                          <div className="images_box_content">
                            <h4>Darcy Middleton</h4>
                            <strong className="user-company">
                              Game Admin, Mt Lawley-Inglewood Cricket Club
                            </strong>
                            <strong className="user-location">Perth, WA</strong>
                            <span>
                              <img
                                src="images/reviews-rating.png"
                                alt="reviews-rating"
                              />
                            </span>
                          </div>
                        </div>
                        <p>
                          "Vicky does a fantastic job with MyClubtap - the
                          system is easy to use, looks fantastic and is a great
                          way to both raise money for the club and for players
                          to bond off field. Could not recommend it enough!"
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="card">
                        <div className="image_box">
                          <figure>
                            <img
                              src="images/reviews-user.jpg"
                              alt="reviews-user"
                            />
                          </figure>
                          <div className="images_box_content">
                            <h4>Darcy Middleton</h4>
                            <strong className="user-company">
                              Game Admin, Mt Lawley-Inglewood Cricket Club
                            </strong>
                            <strong className="user-location">Perth, WA</strong>
                            <span>
                              <img
                                src="images/reviews-rating.png"
                                alt="reviews-rating"
                              />
                            </span>
                          </div>
                        </div>
                        <p>
                          "Vicky does a fantastic job with MyClubtap - the
                          system is easy to use, looks fantastic and is a great
                          way to both raise money for the club and for players
                          to bond off field. Could not recommend it enough!"
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="card">
                        <div className="image_box">
                          <figure>
                            <img
                              src="images/reviews-user.jpg"
                              alt="reviews-user"
                            />
                          </figure>
                          <div className="images_box_content">
                            <h4>Darcy Middleton</h4>
                            <strong className="user-company">
                              Game Admin, Mt Lawley-Inglewood Cricket Club
                            </strong>
                            <strong className="user-location">Perth, WA</strong>
                            <span>
                              <img
                                src="images/reviews-rating.png"
                                alt="reviews-rating"
                              />
                            </span>
                          </div>
                        </div>
                        <p>
                          "Vicky does a fantastic job with MyClubtap - the
                          system is easy to use, looks fantastic and is a great
                          way to both raise money for the club and for players
                          to bond off field. Could not recommend it enough!"
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="card">
                        <div className="image_box">
                          <figure>
                            <img
                              src="images/reviews-user.jpg"
                              alt="reviews-user"
                            />
                          </figure>
                          <div className="images_box_content">
                            <h4>Darcy Middleton</h4>
                            <strong className="user-company">
                              Game Admin, Mt Lawley-Inglewood Cricket Club
                            </strong>
                            <strong className="user-location">Perth, WA</strong>
                            <span>
                              <img
                                src="images/reviews-rating.png"
                                alt="reviews-rating"
                              />
                            </span>
                          </div>
                        </div>
                        <p>
                          "Vicky does a fantastic job with MyClubtap - the
                          system is easy to use, looks fantastic and is a great
                          way to both raise money for the club and for players
                          to bond off field. Could not recommend it enough!"
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="card">
                        <div className="image_box">
                          <figure>
                            <img
                              src="images/reviews-user.jpg"
                              alt="reviews-user"
                            />
                          </figure>
                          <div className="images_box_content">
                            <h4>Darcy Middleton</h4>
                            <strong className="user-company">
                              Game Admin, Mt Lawley-Inglewood Cricket Club
                            </strong>
                            <strong className="user-location">Perth, WA</strong>
                            <span>
                              <img
                                src="images/reviews-rating.png"
                                alt="reviews-rating"
                              />
                            </span>
                          </div>
                        </div>
                        <p>
                          "Vicky does a fantastic job with MyClubtap - the
                          system is easy to use, looks fantastic and is a great
                          way to both raise money for the club and for players
                          to bond off field. Could not recommend it enough!"
                        </p>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
